var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.display ? _c('div', {
    staticClass: "page_loader"
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    key: "0",
    staticClass: "quote_container"
  }, [_vm.$root.theme === 'night' ? _c('img', {
    attrs: {
      "src": "/img/loading.svg"
    }
  }) : _c('img', {
    attrs: {
      "src": "/img/loading_dark.svg"
    }
  })]), _c('div', {
    key: "2",
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.message))]), _vm.contentId ? _c('div', {
    key: "3",
    staticClass: "content_id"
  }, [_vm._v(" " + _vm._s(_vm.contentId) + " ")]) : _vm._e()])], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }